import { Box, Button } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { DEFAULT_PERIOD_TYPE } from 'modules/attendance/components/TimeTracking/Layout/form'

const Navigation = () => {
  const { navigation } = useNavigation()
  const year = moment().year()
  const month = moment().month() + 1
  const pathParams = {
    periodType: DEFAULT_PERIOD_TYPE,
    year,
    month,
    day: 1,
  }
  const exportUrl = navigation.timeTracking.list.periodTypeYearMonthDay.exports.fullPath({
    ...pathParams,
  })

  return (
    <Box gap="s48">
      <Box flexDirection="row" gap="s16" alignItems="center" justifyContent="flexEnd">
        <Button.Router
          type="secondary"
          to={exportUrl}
          onClick={() =>
            track(trackingEvents.timeTracking.specialHoursTableDownloadWorkedHoursButtonPressed)
          }
        >
          {i18n.t(
            'time_tracking.settings.work_time_categories.special_work_hours.info_section.button_title'
          )}
        </Button.Router>
      </Box>
    </Box>
  )
}

export default Navigation
